import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { AppContentsService } from '../../../services/app-contents.service';
import { ManuscriptList } from '../../../models/manuscript';
import { DateCalendar } from '../../../models/date-range';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';

@Component({
  selector: 'app-home-mss-distribution',
  templateUrl: './home-mss-distribution.component.html',
  styleUrls: ['./home-mss-distribution.component.css']
})
export class HomeMssDistributionComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    private mssList: ManuscriptList;
    public chartData: GoogleChartInterface;
    title: SafeHtml;
    subtitle: SafeHtml;

    constructor(
        private sanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService,
        private appContentsService: AppContentsService
    ) {
    }

    ngOnInit() {
        this.title = globals.html_small_loading_gif;
        this.subtitle = globals.html_small_loading_gif;

        /* Static contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('home')
                .subscribe(
                    page => {
                        if (page && page.name === 'home') {
                            const contents = page.contents.find(c => c.name === 'mss-distribution');
                            if (contents) {
                                this.title = this.sanitizer.bypassSecurityTrustHtml(contents.title);
                                this.subtitle = this.sanitizer.bypassSecurityTrustHtml(contents.text);
                            }
                        }
                    },
                    err => console.error(err)
                )
        );

        /* Reset filters without reloading manuscript list */
        this.manuscriptsService.resetFilters(false);

        /* Load manuscript list */
        this.subscriptions.push(
            this.manuscriptsService.getManuscripts(false)
                .subscribe(response => {
                    this.mssList = response;
                    this.initChart();
                },
                    err => console.error(err)
                )
        );
    }

    initChart(): void {
        if (this.mssList && this.mssList.length > 0) {
            /* Discard attested manuscripts before counting mss */
            const chartMssCount = this.mssList.filter(ms => ms.fkidms_types !== 2 /* attested */).length;

            /* Load chart data */
            const colStyle = 'opacity: 0.8';
            this.chartData = {
                chartType: 'LineChart',
                dataTable: [
                    ['Project', 'Number of manuscripts', { role: 'style' }],
                    ['Brockelmann 1898', 7, colStyle],
                    ['Brockelmann 1937', 25, colStyle],
                    ['Ergin 1937', 27, colStyle],
                    ['Anawati 1950', 63, colStyle],
                    ['Mahdavi 1954\nGutas 2014', 77, colStyle],
                    ['Bertolacci 2008', 111, colStyle],
                    ['PhiBor ' + (new Date()).getFullYear(), chartMssCount, colStyle]
                ],
                options: {
                    colors: ['#6c95a7', '#ba7c40'],
                    lineWidth: 5,
                    title: '',
                    titleTextStyle: {
                        fontSize: 32,
                        fontName: '"Open Sans", sans-serif',
                        bold: false,
                        color: '#784444'
                    },
                    pointSize: 10,
                    height: 600,
                    hAxis: {
                        title: ''
                    },
                    vAxis: {
                        title: ''
                    },
                    isStacked: true,
                    annotations: {
                        textStyle: {
                            fontName: '"Open Sans", sans-serif',
                            opacity: 0.8
                        }
                    }
                }
            };
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/home-mss-distribution/home-mss-distribution.component.ts